import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

const LegalPage = ({ title, icon: Icon, children }) => (
  <div className="min-h-screen bg-gray-950 pt-24 pb-16 px-4">
    <div className="max-w-3xl mx-auto">
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
          <Icon size={14} className="text-primary-400" />
          <span className="text-sm text-primary-300">Legal</span>
        </div>
        <h1 className="text-4xl font-bold text-white mb-4">{title}</h1>
        <p className="text-gray-500 text-sm">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </motion.div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
        className="bg-gray-900/50 border border-gray-800/60 rounded-2xl p-8 prose prose-invert prose-sm max-w-none">
        {children}
      </motion.div>
    </div>
  </div>
);

const TermsOfService = () => (
  <LegalPage title="Terms of Service" icon={FileText}>
    <h2>1. Acceptance of Terms</h2>
    <p>By accessing and using Advance Advert Tv Digital, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.</p>

    <h2>2. Service Description</h2>
    <p>Advance Advert Tv Digital provides foreign TikTok account creation services. We create TikTok accounts registered in foreign countries (UK, USA, Canada, etc.) and deliver the login credentials to you.</p>

    <h2>3. User Responsibilities</h2>
    <ul>
      <li>Provide accurate and complete information during the order process</li>
      <li>Use a valid email address that has not been previously used on TikTok</li>
      <li>Maintain the security of your account credentials after delivery</li>
      <li>Comply with TikTok's Terms of Service and Community Guidelines</li>
    </ul>

    <h2>4. Payment Terms</h2>
    <ul>
      <li>All payments are processed through Flutterwave</li>
      <li>Prices are displayed in Nigerian Naira (NGN)</li>
      <li>Payment must be completed before account creation begins</li>
      <li>We reserve the right to change prices with notice</li>
    </ul>

    <h2>5. Delivery</h2>
    <ul>
      <li>Accounts are typically delivered within 24 hours of payment confirmation</li>
      <li>Delivery times may vary based on order volume</li>
      <li>Login credentials are sent to your registered email address</li>
    </ul>

    <h2>6. Prohibited Activities</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use the account for illegal activities</li>
      <li>Resell or transfer the account to third parties</li>
      <li>Use the account to impersonate others</li>
      <li>Violate TikTok's Terms of Service</li>
    </ul>

    <h2>7. Limitation of Liability</h2>
    <p>Advance Advert Tv Digital is not liable for:</p>
    <ul>
      <li>Account suspension or banning by TikTok</li>
      <li>Loss of account due to user negligence</li>
      <li>Indirect or consequential damages</li>
    </ul>

    <h2>8. Changes to Terms</h2>
    <p>We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of updated terms.</p>

    <h2>9. Contact</h2>
    <p>For questions about these Terms, contact us at contact@advanceadverttvdigital.com.</p>
  </LegalPage>
);

export default TermsOfService;
